import * as Models from "../_models";
/* NgRx */
import { createReducer, on } from '@ngrx/store';
import { FiltroApiActions, FiltroPageActions } from './actions';
import { MateriaMin } from 'src/app/unidad-buscar/models/unidad-setup';

export interface FiltroState {
  loading: boolean;
  error: string;
  materias: MateriaMin[];
  materiasMcp: MateriaMin[];
  selectedMaterias:  number[];
  cursos: Models.CursoDto[];
  selectedCursos: number[];
  selectedCurso: number;
  periodos: Models.Periodo[];
  selectedPeriodos: number[];
  selectedPeriodo: number;
  selectedNombre: string;
  selectedMateria: number;
  sesiones: Models.SesionDto[];
  selectedSesiones: number[];
  selectedIsNuevo: boolean;
}

const initialState: FiltroState = {
  loading: false,
  error: '',
  materias: [],
  materiasMcp: [],
  selectedMaterias: [],
  cursos: [],
  selectedCursos: [],
  selectedCurso: 0,
  periodos: [],
  selectedPeriodos: [],
  selectedPeriodo: 0,
  selectedNombre: '',
  selectedMateria: 0,
  sesiones: [],
  selectedSesiones: [],
  selectedIsNuevo: false,
};

export const filtroReducer = createReducer<FiltroState>(
  initialState,
  on(FiltroPageActions.loadMaterias, FiltroPageActions.loadMateriasMcp, (state): FiltroState => {
    return {
      ...state,
      loading: true,
    }
  }),
  on(FiltroApiActions.loadMateriasSuccess, (state, action): FiltroState => {
    return {
      ...state,
      materias: action.materias,
      error: '',
      loading: false
    }
  }),
  on(FiltroApiActions.loadMateriasFailure, (state, action): FiltroState => {
    return {
      ...state,
      materias: [],
      error: action.error,
      loading: false,
    }
  }),
  on(FiltroPageActions.selectedMaterias, (state, action): FiltroState => {
    return {
      ...state,
      selectedMaterias: action.selectedMaterias,
    }
  }),
  on(FiltroPageActions.cleanSelectedMaterias, (state): FiltroState => {
    return {
      ...state,
      selectedMaterias: []
    }
  }),
  on(FiltroPageActions.loadCursos, (state, action): FiltroState => {
    return {
      ...state,
      loading: true,
    }
  }),
  on(FiltroApiActions.loadCursosSuccess, (state, action): FiltroState => {
    return {
      ...state,
      cursos: action.cursos,
      error: '',
      loading: false
    }
  }),
  on(FiltroApiActions.loadCursosFailure, (state, action): FiltroState => {
    return {
      ...state,
      cursos: [],
      error: action.error,
      loading: false
    }
  }),
  on(FiltroPageActions.selectedCursos, (state, action): FiltroState => {
    return {
      ...state,
      selectedCursos: action.selectedCursos,
    }
  }),
  on(FiltroPageActions.selectedCurso, (state, action): FiltroState => {
    return {
      ...state,
      selectedCurso: action.selectedCurso,
    }
  }),
  on(FiltroPageActions.cleanSelectedCursos, (state): FiltroState => {
    return {
      ...state,
      selectedCursos: []
    }
  }),
  on(FiltroPageActions.loadPeriodos, (state): FiltroState => {
    return {
      ...state,
      loading: true,
    }
  }),
  on(FiltroApiActions.loadPeriodosSuccess, (state, action): FiltroState => {
    return {
      ...state,
      periodos: action.periodos,
      error: '',
      loading: false
    }
  }),
  on(FiltroApiActions.loadPeriodosFailure, (state, action): FiltroState => {
    return {
      ...state,
      periodos: [],
      error: action.error,
      loading: false
    }
  }),
  on(FiltroPageActions.selectedPeriodos, (state, action): FiltroState => {
    return {
      ...state,
      selectedPeriodos: action.selectedPeriodos,
    }
  }),
  on(FiltroPageActions.selectedPeriodo, (state, action): FiltroState => {
    return {
      ...state,
      selectedPeriodo: action.selectedPeriodo,
    }
  }),
  on(FiltroPageActions.cleanSelectedPeriodos, (state): FiltroState => {
    return {
      ...state,
      selectedPeriodos: []
    }
  }),
  on(FiltroPageActions.selectedNombre, (state, action): FiltroState => {
    return {
      ...state,
      selectedNombre: action.selectedNombre,
    }
  }),

  on(FiltroApiActions.loadMateriasMcpSuccess, (state, action): FiltroState => {
    return {
      ...state,
      materiasMcp: action.materiasMcp,
      error: '',
      loading: false
    }
  }),
  on(FiltroApiActions.loadMateriasMcpFailure, (state, action): FiltroState => {
    return {
      ...state,
      materiasMcp: [],
      error: action.error,
      loading: false,
    }
  }),
  on(FiltroPageActions.selectedMateria, (state, action): FiltroState => {
    return {
      ...state,
      selectedMateria: action.selectedMateria,
    }
  }),

  //
  on(FiltroPageActions.loadSesiones, (state): FiltroState => {
    return {
      ...state,
      loading: true,
    }
  }),
  on(FiltroApiActions.loadSesionesSuccess, (state, action): FiltroState => {
    return {
      ...state,
      sesiones: action.sesiones,
      error: '',
      loading: false
    }
  }),
  on(FiltroApiActions.loadSesionesFailure, (state, action): FiltroState => {
    return {
      ...state,
      sesiones: [],
      error: action.error,
      loading: false
    }
  }),
  on(FiltroPageActions.selectedSesiones, (state, action): FiltroState => {
    return {
      ...state,
      selectedSesiones: action.selectedSesiones,
    }
  }),
  on(FiltroPageActions.cleanSelectedSesiones, (state): FiltroState => {
    return {
      ...state,
      selectedSesiones: []
    }
  }),
  on(FiltroPageActions.selectedIsNuevo, (state, action): FiltroState => {
    return {
      ...state,
      selectedIsNuevo: action.selectedIsNuevo,
    }
  }),
);
